import { Link } from 'react-router-dom';
import { Dialog } from '../api/types';
import clsx from 'clsx';
import { formattedDate } from '../../../utils/dates';

type DialogCardProps = {
  dialog: Dialog;
};

export const DialogCard = ({ dialog }: DialogCardProps) => {
  const userInitials = dialog.recipient.full_name
    .split(' ')
    .map((word) => word[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <Link to={`/chat/${dialog.id}`}>
      <div className="flex justify-between items-center py-3 px-4 border-b border-cyan-800 cursor-pointer gap-2 w-full">
        <div className="flex  w-full gap-2">
          <div className="w-10 h-10 bg-cyan-500 rounded-full flex items-center justify-center font-bold text-white">
            <span>{userInitials}</span>
          </div>

          <div className="flex items-center justify-between flex-1 gap-2">
            <div className="flex flex-col">
              <p className="text-sm flex items-center gap-1">
                {dialog.recipient.full_name}

                <div
                  className={clsx(
                    'w-2 h-2 rounded-full',
                    dialog.recipient.is_online ? 'bg-green-500' : 'bg-red-500'
                  )}
                />
              </p>
              {dialog.last_message && (
                <p className="text-xs text-cyan-700 truncate text-ellipsis max-w-[9rem]">
                  {dialog.last_message.text}
                </p>
              )}
            </div>
            {dialog.last_message && (
              <div className="flex flex-col gap-1 items-end">
                <p className="text-[.6rem] text-cyan-700">
                  {formattedDate(new Date(dialog.last_message.created))}
                </p>
                {Boolean(dialog.unread_messages) && (
                  <div className="text-[.7rem] font-bold w-4 h-4 flex text-white items-center justify-center rounded-full bg-green-600 align-middle">
                    <span className="absolute">{dialog.unread_messages}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};
